import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './TransactionsEmpty.styles';
import NoSsr from '@/components/NoSsr/NoSsr';

interface TransactionsEmptyProps {
  headerHeight: number;
  type: string;
}

export const TransactionsEmpty: React.FC<TransactionsEmptyProps> = ({
  headerHeight,
  type,
}) => {
  const { t } = useTranslation();

  return (
    <S.Box $headerHeight={headerHeight}>
      <img
        src="/transactions-empty.png"
        alt=""
        width={255}
        height={191}
        loading="lazy"
      />
      <S.Title $variant="3">
        {t('pages.cabinet.you_dont_have_any_operations_yet')}
      </S.Title>
      <NoSsr>
        <S.Subtitle $variant="1">
          {type === 'account'
            ? t('pages.cabinet.here_will_be_displayed_account_history')
            : t('pages.cabinet.here_will_be_displayed_ads_history')}
        </S.Subtitle>
      </NoSsr>
    </S.Box>
  );
};
